import type { CityConfig } from "../city-template/types";

export const duluthMnConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Minnesota Vital Records (Birth, Death)", href: "https://www.health.state.mn.us/people/vitalrecords/", description: "Official Minnesota Department of Health vital records office in St. Paul" },
    { label: "St. Louis County — Marriage &amp; Vital Records", href: "https://www.stlouiscountymn.gov/", description: "St. Louis County — marriage licenses and vital records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of MN DOH for online vital record orders" },
  ],
  city: "Duluth",
  state: "Minnesota",
  stateAbbr: "MN",
  slug: "duluth-mn",
  route: "/cities/duluth-mn",
  title: "Emergency & Fast Passport Renewal Duluth MN | Same-Day & Expedited | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Duluth, MN — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for St. Louis County and North Shore travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Duluth, MN",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Duluth and North Shore travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Duluth%20Minnesota%20harbor%20at%20golden%20hour%20with%20Aerial%20Lift%20Bridge%20over%20Lake%20Superior%2C%20modern%20waterfront%20district%20with%20historic%20warehouses%2C%20warm%20amber%20sunset%20light%2C%20professional%20cityscape%20photography%20with%20rich%20warm%20earth%20tones%20and%20blue%20lake%20waters%2C%20no%20readable%20text%20or%20people%2C%20clean%20and%20inviting%20atmosphere&width=1800&height=700&seq=duluth-mn-hero-001&orientation=landscape",
  heroImageAlt: "Duluth Minnesota harbor with Aerial Lift Bridge over Lake Superior at golden hour",
  geoPosition: "46.7867;-92.1005",
  geoPlacename: "Duluth, Minnesota",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, Chicago, IL 60605",
    distance: "Chicago is 7+ hours by car from Duluth — our courier eliminates the need to drive",
  },
  nearbyCitiesZips: [
    { name: "Downtown Duluth", zips: "55802" },
    { name: "Canal Park", zips: "55802" },
    { name: "East Hillside", zips: "55812" },
    { name: "West Duluth", zips: "55807" },
    { name: "Superior WI", zips: "54880" },
    { name: "Hermantown", zips: "55810, 55811" },
    { name: "Proctor", zips: "55810" },
    { name: "Cloquet", zips: "55720" },
    { name: "Two Harbors", zips: "55616" },
    { name: "Silver Bay", zips: "55614" },
    { name: "Grand Marais", zips: "55604" },
    { name: "Hibbing", zips: "55746" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent North Shore departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Minneapolis", route: "/cities/minneapolis" },
    { name: "Emergency passport help in St. Paul", route: "/cities/st-paul" },
    { name: "Urgent passport services in Rochester", route: "/cities/rochester-mn" },
    { name: "Expedited passport services in Wisconsin", route: "/states/illinois" },
    { name: "Passport courier services in Twin Cities", route: "/cities/minneapolis" },
    { name: "Rush passport help in Chicago", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Duluth remotely via secure courier. We do not have a walk-in office in Duluth — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for North Shore travelers.",
  fpcOfficeDistance: "Serving all of St. Louis County and the North Shore",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout the entire Duluth area and North Shore. From Canal Park to the Iron Range, from Superior WI to Grand Marais — we help North Shore travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Duluth neighborhoods and nearby communities including Superior, Hermantown, Proctor, Cloquet, Two Harbors, and Silver Bay. If you are on the North Shore or the Iron Range, we have you covered.",
  howItWorksIntro: "Most Duluth travelers complete everything online and ship documents overnight. No need to drive to Chicago or the Twin Cities. Our emergency and expedited passport process is designed for North Shore travelers who need fast, reliable results.",
  mistakesIntro: "With Duluth being a major port and outdoor recreation gateway, North Shore travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Duluth travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Duluth? Here are the most common ones we hear from North Shore travelers.",
  statePageRoute: "/states/minnesota",
  statePageName: "Minnesota",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent North Shore international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Mark H.",
      location: "Canal Park, Duluth, MN",
      rating: 5,
      text: "My flight to Iceland was in 4 days and I realized my passport was expired. Fast Passport Center got me a new one in 48 hours. Saved my photography trip completely.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa P.",
      location: "Hermantown, MN",
      rating: 5,
      text: "I needed to renew my passport for a family cruise to the Caribbean. The process was smooth, they reviewed my documents, and I had my passport in 5 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Tom B.",
      location: "Superior, WI",
      rating: 5,
      text: "Lost my passport the week before my fishing trip to Canada. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Amy C.",
      location: "Duluth, MN",
      rating: 5,
      text: "As a UMD professor who travels for research, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable every time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "dul-1",
      name: "Duluth Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4802 Mike Colalillo Dr",
      city: "Duluth",
      state: "MN",
      zip: "55807",
      phone: "(218) 722-9631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles from downtown Duluth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "dul-2",
      name: "Duluth Heights Station",
      type: "USPS Passport Acceptance Facility",
      address: "1405 E Superior St",
      city: "Duluth",
      state: "MN",
      zip: "55805",
      phone: "(218) 728-7231",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.5 miles from downtown Duluth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "dul-3",
      name: "Hermantown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4901 W Arrowhead Rd",
      city: "Hermantown",
      state: "MN",
      zip: "55811",
      phone: "(218) 729-6231",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from downtown Duluth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for north metro residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "dul-4",
      name: "Cloquet City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "1309 Avenue B",
      city: "Cloquet",
      state: "MN",
      zip: "55720",
      phone: "(218) 879-6758",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "20 miles from downtown Duluth",
      website: "https://www.cloquetmn.gov/",
      websiteLabel: "Cloquet City Clerk",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-government-line",
    },
    {
      id: "dul-5",
      name: "Two Harbors Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "622 1st Ave",
      city: "Two Harbors",
      state: "MN",
      zip: "55616",
      phone: "(218) 834-5531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "27 miles from downtown Duluth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for North Shore residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "dul-6",
      name: "St. Louis County Service Center",
      type: "County Clerk Passport Acceptance",
      address: "320 W 2nd St",
      city: "Duluth",
      state: "MN",
      zip: "55802",
      phone: "(218) 726-2355",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.5 miles from downtown Duluth",
      website: "https://www.stlouiscountymn.gov/",
      websiteLabel: "St. Louis County",
      notes: "Major county facility. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 7+ hours to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Duluth photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Duluth acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Duluth applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Duluth families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "North Shore travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Duluth." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Duluth address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Duluth?",
      a: "Fast Passport Center offers emergency passport processing in Duluth in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for North Shore travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Duluth?",
      a: "Same-day passports are only available at regional passport agencies for documented life-or-death emergencies with proof of travel within 72 hours. The nearest agency to Duluth is in Chicago — a 7+ hour drive. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Duluth residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Duluth?",
      a: "Fast Passport Center offers fast passport renewal in Duluth with no office visit required. We serve all St. Louis County neighborhoods including Canal Park, East Hillside, Hermantown, and Superior WI. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Duluth?",
      a: "The fastest way to get an urgent passport in Duluth is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than standard mail processing (8–11 weeks) or even government expedited mail (2–3 weeks).",
    },
    {
      q: "How fast can I get a passport in Duluth?",
      a: "With Fast Passport Center's emergency courier service, Duluth travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to visit a passport agency in person?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Duluth?",
      a: "Popular options include the Duluth Main Post Office (55807), Duluth Heights Station (55805), Hermantown Post Office (55811), and St. Louis County Service Center (55802). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "What if I live on the North Shore like Two Harbors or Grand Marais?",
      a: "We serve all of the North Shore including Two Harbors, Silver Bay, and Grand Marais. Our overnight shipping labels work from any UPS location, so your location on the North Shore doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Duluth?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Duluth?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Duluth offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Duluth?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Duluth?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Duluth families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Duluth", address: "2102 E Superior St, Duluth, MN 55812", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Duluth", address: "1415 E Superior St, Duluth, MN 55805", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Duluth", address: "1500 Miller Trunk Hwy, Duluth, MN 55811", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Hermantown", address: "4503 Haines Rd, Hermantown, MN 55811", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Duluth", address: "3800 Grand Ave, Duluth, MN 55807", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Superior WI", address: "1425 N 14th St, Superior, WI 54880", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Cloquet", address: "1308 Avenue B, Cloquet, MN 55720", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Two Harbors", address: "1000 11th St, Two Harbors, MN 55616", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "DMV — Duluth",
      address: "5002 Miller Trunk Hwy, Duluth, MN 55811",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Hermantown",
      address: "4802 Lavaque Rd, Hermantown, MN 55811",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Cloquet",
      address: "1410 Big Lake Rd, Cloquet, MN 55720",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Two Harbors",
      address: "5200 Avenue of the Pines, Two Harbors, MN 55616",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for North Shore residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DLH",
      name: "Duluth International Airport",
      distance: "7 miles from downtown Duluth",
      address: "4701 Grinden Dr, Duluth, MN 55811",
      note: "The primary airport for the North Shore. Offers domestic flights and some international connections via major hubs.",
      flightUrl: "https://www.duluthairport.com/",
      flightLabel: "DLH Flight Info",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis–Saint Paul International Airport",
      distance: "160 miles from Duluth",
      address: "4300 Glumack Dr, St. Paul, MN 55111",
      note: "Major international hub for North Shore travelers connecting through MSP.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Flight Info",
      featured: false,
    },
  ],
};